import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AdminDashboard = ({ history }) => {
  return (
    <Container
      className='mt-4 py-3 d-print-none'
      style={{
        backgroundColor: 'white',
        boxShadow: '0 0 5px 0.1px #ccc',
        borderRadius: '5px',
      }}
    >
      <Row className='justify-content-md-center'>
        <Col xs={12} md={12}>
          <Row>
            <Col>
              <h5>Links de Gerenciamento</h5>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className='justify-content-md-center mt-3'>
        <Col xs={12} md={6}>
          <h6>Gerenciamento de Usuarios</h6>
          <Link to='/admin/users'>Lista de usuários</Link>
        </Col>
        <Col xs={12} md={6}>
          <h6>Gerenciamento de Respostas</h6>
          <Link to='/admin/answers'>Lista de respostas</Link>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
